<template>
    <nav v-if="$user.type" class="MemberAreaNav" :class="{'is-open': isOpen}"
         @click.prevent="isOpen = !isOpen">
        <div class="MemberAreaNav__item" :class="{'is-active': active === 'chat'}" @click="handleClick('chat')">
            <span class="MemberAreaNav__item-label">Ma communauté</span>
        </div>
        <div v-if="$user.type === $enums.UserType.LEARNER"
             @click="handleClick('formations')"
             :class="{
                'MemberAreaNav__item': true,
                'is-active': active === 'formations_root'
            }">
            <span class="MemberAreaNav__item-label">Mes formations</span>
        </div>
        <div v-else-if="$user.type === $enums.UserType.COMPANY"
             @click="handleClick('folders')"
             :class="{
                'MemberAreaNav__item': true,
                'is-active': active === 'folders_root'
            }">
            <span class="MemberAreaNav__item-label">Mes employés</span>
        </div>
        <div @click="openSurveyModal" class="MemberAreaNav__item" v-if="surveyEnabled">
            <span class="MemberAreaNav__item-label">Votre enquête</span>
        </div>
        <div @click="openAccommodationModal" class="MemberAreaNav__item" v-if="accommodationEnabled && $user.type === $enums.UserType.LEARNER">
            <span class="MemberAreaNav__item-label">Paiement de l'hébergement</span>
        </div>
        <div v-for="item in items"
             @click.stop
             :class="{'MemberAreaNav__item': true, 'has-dropdown': !!item.children , 'is-open': subOpenId ===  item.id}">
            <span v-if="!!item.children" class="MemberAreaNav__item-label"
                  @click.stop="subOpenId = (subOpenId === item.id ? null : item.id)">
                {{ item.label }}
            </span>
            <a v-else class="MemberAreaNav__item-label" :href="item.url" target="_blank">
                {{ item.label }}
            </a>
            <ul class="MemberAreaNav__sub">
                <li v-for="child in item.children" class="MemberAreaNav__sub-item" @click.stop>
                    <a :href="child.url" target="_blank">{{ child.label }}</a>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>

    import ModalBus from "../eventBus";
    import SurveyModal from "./Modals/SurveyModal";
    import AccommodationModal from "./Modals/AccommodationModal";

    export default {
        props: ['items', 'surveyEnabled', 'accommodationEnabled'],
        data: function () {
            return {
                isOpen: false,
                subOpenId: null
            }
        },
        computed: {
            active: function () {
                return this.$route.matched[0].name;
            }
        },
        methods: {
            handleClick: function (name) {
                if (this.$route.name !== name) {
                    this.$router.push({name})
                }
            },
            openSurveyModal: function(){
                ModalBus.open({component: SurveyModal, props: {}})
            },
            openAccommodationModal: function(){
                ModalBus.open({component: AccommodationModal, props: {}})
            }
        }
    }
</script>
